import service from "./service"

const fetchPreCheckUpdateId = async (key) => {
    return await service(key)
}

export default fetchPreCheckUpdateId
